import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Diagnosis from '@/components/Diagnosis';
import Intro from '@/components/Intro';
import IntroForm from '@/components/IntroForm';
import Peoples from '@/components/Peoples';
import PeoplesForm from '@/components/PeoplesForm';
import Process from '@/components/Process';
import ProcessForm from '@/components/ProcessForm';
import Customer from '@/components/Customer';
import CustomerForm from '@/components/CustomerForm';
import Strategy from '@/components/Strategy';
import StrategyForm from '@/components/StrategyForm';
import Conclusion from '@/components/Conclusion';
import Result from '@/components/Result';


import TestIntro from '@/components/test/Intro';
import TestCultureAndLeadership from '@/components/test/CultureAndLeadership';
import TestCultureAndLeadershipForm from '@/components/test/CultureAndLeadershipForm';
import TestOperationalAgility from '@/components/test/OperationalAgility';
import TestOperationalAgilityForm from '@/components/test/OperationalAgilityForm';
import TestDigitalTechnology from '@/components/test/DigitalTechnology';
import TestDigitalTechnologyForm from '@/components/test/DigitalTechnologyForm';
import TestCustomerExperience from '@/components/test/CustomerExperience';
import TestCustomerExperienceForm from '@/components/test/CustomerExperienceForm';
import TestDigitalEntrepreneurship from '@/components/test/DigitalEntrepreneurship';
import TestDigitalEntrepreneurshipForm from '@/components/test/DigitalEntrepreneurshipForm';
import TestConclusion from '@/components/test/Conclusion';
import TestResult from '@/components/test/Result';

import TestInvalidLink from '@/components/test/InvalidLink';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/diagnotico',
      name: 'Diagnótico',
      component: Diagnosis,
    },
    {
      path: '/intro',
      component: Intro,
    },
    {
      path: '/intro/formulario',
      component: IntroForm,
    },
    {
      path: '/pessoas',
      component: Peoples,
    },
    {
      path: '/pessoas/formulario',
      component: PeoplesForm,
    },
    {
      path: '/processos',
      component: Process,
    },
    {
      path: '/processos/formulario',
      component: ProcessForm,
    },
    {
      path: '/cliente',
      component: Customer,
    },
    {
      path: '/cliente/formulario',
      component: CustomerForm,
    },
    {
      path: '/estrategia',
      component: Strategy,
    },
    {
      path: '/estrategia/formulario',
      component: StrategyForm,
    },
    {
      path: '/conclusao',
      component: Conclusion,
    },
    {
      path: '/resultado',
      component: Result,
    },
    {
      path: '/teste',
      component: TestIntro,
    },
    {
      path: '/teste/cultura-e-lideranca',
      component: TestCultureAndLeadership,
    },
    {
      path: '/teste/cultura-e-lideranca/formulario',
      component: TestCultureAndLeadershipForm,
    },
    {
      path: '/teste/agilidade-operacional',
      component: TestOperationalAgility,
    },
    {
      path: '/teste/agilidade-operacional/formulario',
      component: TestOperationalAgilityForm,
    },
    {
      path: '/teste/tecnologia-digital',
      component: TestDigitalTechnology,
    },
    {
      path: '/teste/tecnologia-digital/formulario',
      component: TestDigitalTechnologyForm,
    },
    {
      path: '/teste/experiencia-do-cliente',
      component: TestCustomerExperience,
    },
    {
      path: '/teste/experiencia-do-cliente/formulario',
      component: TestCustomerExperienceForm,
    },
    {
      path: '/teste/empreendedorismo-digital',
      component: TestDigitalEntrepreneurship,
    },
    {
      path: '/teste/empreendedorismo-digital/formulario',
      component: TestDigitalEntrepreneurshipForm,
    },
    {
      path: '/teste/conclusao',
      component: TestConclusion,
    },
    {
      path: '/teste/resultado',
      component: TestResult,
    },
    {
      path: '/teste/link-invalido',
      component: TestInvalidLink,
    },
    {
      path: '*',
      component: Home,
    }
  ],
  scrollBehavior(to) {
    if (to.hash)
      return { selector: to.hash }

    return false
  }
});




export default (store) => {

  router.beforeEach((to, from, next) => {
    if (to.path != '/teste/link-invalido' && /^\/teste/g.test(to.path) && !store.state.userid) 
      return next('/teste/link-invalido');

    next();
  });

  return router;
};


// WEBPACK FOOTER //
// ./src/router/index.js